<template>
    <section class="signup-section spad set-bg">
        <div class="signup-warp d-flex">
            <!-- signup form -->
            <div class="signup-container ml-auto mr-auto mt-sm-5">
            <!-- signup form -->
                <form class="signup-form m-3 m-sm-0 pt-5" v-if="!updateSuccessful" v-on:submit.prevent="updatePassword">
                    <p class="h2 mb-4">Establecer nueva contraseña</p>
                    <input type="password" name="password" id="password" :class="{'margin-zero': errors.has('password')}" placeholder="Nueva contraseña" v-model="password" v-validate="{ required: true, regex: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/ }">
                    <p class="form-error" v-show="errors.has('password')">{{ errors.first('password') }}</p>
                    <input type="password" name="repeatPassword" id="repeatPassword" :class="{'margin-zero': errors.has('repeatPassword')}" placeholder="Repetir nueva contraseña" v-model="repeatPassword" v-validate="'required|samePassword'" data-vv-as="Repetir contraseña">
                    <p class="form-error" v-show="errors.has('repeatPassword')">{{ errors.first('repeatPassword') }}</p>
                    <vue-recaptcha id="captcha" sitekey="6LfCJuIZAAAAALtujhJ0zzJ5_Jn6RuzIjtfJaRWz" :loadRecaptchaScript="true" @verify="isVerified = true" @expired="isVerified = false"></vue-recaptcha>
                    <input type="submit" value="Cambiar contraseña" class="site-btn" v-if="!loading" :disabled="!isVerified">
                    <div class="loader-container" v-else>
                        <div class="loader"></div>
                    </div>
                    <p v-if="errorMsg" class="api-error">{{errorMsg}}</p>
                </form>
                <div class="signup-form m-3 m-sm-0 pt-5" v-else>
                    <p class="h2 mb-4">Establecer nueva contraseña</p>
                    <div class="text-left mb-2">
                        <h4>¡Contraseña actualizada!</h4>
                    </div>
                    <div class="text-left text-muted mb-4">Tu contraseña ha sido cambiada con éxito. Ya puedes iniciar sesión con tu nueva contraseña.</div>
                    <br>
                    <router-link to="/login" class="d-table m-auto">
                        <button class="site-btn header-btn">Iniciar sesión</button>
                    </router-link>
                </div>
            </div>
		</div>
	</section>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import messagesEs from 'vee-validate/dist/locale/es.js';
import VueRecaptcha from 'vue-recaptcha';

import { API_URL } from '@/config.js'

Vue.use(VeeValidate, {
    locale: 'es',
    events: 'blur',
    dictionary: {
        es: messagesEs
    }
});

Validator.localize('es', { 
    custom: {
        password: {
            required: 'Debes introducir la nueva contraseña',
            regex: 'La contraseña debe tener como mínimo 8 caracteres y debe incluir al menos una mayúscula, una minúscula y un número'
        },
        repeatPassword: {
            required: 'Debes introducir de nuevo la contraseña'
        }
    }
});

export default {
    name: 'register',
    components: { VueRecaptcha },
    data() {
        return {
            password: null,
            repeatPassword: null,
            errorMsg: null,
            loading: false,
            updateSuccessful: false,
            isVerified: false
        }
    },
    created() {
        this.$validator.extend('samePassword', {
            getMessage: 'Las contraseñas deben coincidir',
            validate: value => {
                return value && value != '' && value == this.password
            }
        });
    },
    methods: {
        updatePassword() {
            this.loading = true;
            this.errorMsg = null;
            this.$validator.validate().then(valid => {
                if (valid && this.isVerified) {
                    axios.post(`${API_URL}/public/user/recover/password`, {
                        token: this.$route.params.token,
                        password: this.password
                    })
                        .then(response => {
                            this.loading = false;
                            if (response.data && response.data.result == true) {
                                this.updateSuccessful = true;
                            } else {
                                this.errorMsg = "Se ha producido un error al actualizar la contraseña. Inténtalo de nuevo en unos minutos.";
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.errorMsg = "Se ha producido un error al actualizar la contraseña. Inténtalo de nuevo en unos minutos.";
                        });
                } else {
                    this.loading = false;
                    if (valid && !this.isVerified) {
                        this.isVerified = false;
                        this.errorMsg = "Por favor, verifica el captcha para comprobar que no eres un robot.";
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/variables.scss";
    .signup-section {
        min-height: calc(100vh - 48px);
        padding-top: $header-unauth-height;
        background-color: $main-color-brown;
        background-image: url("https://www.justcompileit.com/videos/cursos-streaming/images/register.jpg");
        .signup-container {
            width: 100vw;
            max-width: 700px;
            box-sizing: border-box;
        }
        .signup-form {
            input[type=password] {
                height: 57px;
                width: 100%;
                padding: 0 30px;
                margin-bottom: 27px;
                float: left;
                border: none;
                font-size: 14px;
                font-weight: 500;
                background: #edf4f6;
            }
            input.margin-zero {
                margin-bottom: 4px;
                background:#ffdfdf !important;
            }
            .form-error {
                display: inherit;
                text-align: left;
                color: red;
                margin-left: 10px;
                margin-bottom: 8px;
                line-height: 16px;
            }
            .api-error {
                color: red;
                margin: 15px 10px -10px;
                font-size: 16px;
                line-height: 20px;
            }
            #captcha {
                display: table;
                margin: auto;
                margin-bottom: 20px;
            }
        }
    }
</style>

